import React from 'react';
import { appendUtmParams } from '../utils/utm-params';

/**
 * ExternalLink — păstrează UTM la redirect către my.brain-event.com (ca pe landing principal).
 */
const ExternalLink = ({ href, children, className, ...props }) => {
  const handleClick = (e) => {
    if (href && href.includes('my.brain-event.com')) {
      e.preventDefault();
      const urlWithParams = appendUtmParams(href);
      window.location.href = urlWithParams;
    }
  };

  return (
    <a href={href} className={className} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default ExternalLink;
